/**
 * Gestoria Moreno - v1.0.0
 * Aviso Legal (LSSI-CE)
 */

import { useEffect } from "react";
import Container from "@mui/material/Container";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import SEO from "components/SEO";

import routes from "routes";
import footerRoutes from "footer.routes";
import logoImg from "assets/images/logo.png";

function AvisoLegal() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Aviso Legal - Gestoría Moreno Granada"
        description="Aviso legal de Gestorías Moreno Martín Alhambra S.L.P. Información sobre el titular del sitio web conforme a la LSSI-CE."
        canonicalUrl="/aviso-legal"
        robots="noindex, follow"
      />
      <MKBox position="fixed" top="0.5rem" width="100%" sx={{ zIndex: 9999 }}>
        <DefaultNavbar
          brand={
            <img
              src={logoImg}
              alt="Logo Gestoría Moreno"
              width="106"
              height="50"
              style={{
                height: "50px",
                width: "auto",
                imageRendering: "-webkit-optimize-contrast",
              }}
            />
          }
          routes={routes}
          sticky
        />
      </MKBox>
      <MKBox pt={18} pb={6} px={3}>
        <Container sx={{ maxWidth: "900px !important" }}>
          <MKTypography variant="h2" mb={4}>
            Aviso Legal
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            1. Datos identificativos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la
            Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa que el titular
            de este sitio web es:
            <br />
            <br />
            <strong>Denominación social:</strong> Gestorías Moreno Martín Alhambra S.L.P.
            <br />
            <strong>CIF:</strong> B18492264
            <br />
            <strong>Domicilio social:</strong> Avenida Divina Pastora, 9, local 13, 18012 Granada
            <br />
            <strong>Registro Mercantil:</strong> Registro Mercantil de Granada. Tomo 834, Folio 34,
            Hoja GR-19959.
            <br />
            <strong>Teléfono:</strong> 958 805 110
            <br />
            <strong>Email:</strong> info@gestoriamoreno.com
            <br />
            <strong>Actividad:</strong> Servicios de gestoría administrativa, asesoría fiscal,
            laboral y contable
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            2. Objeto
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            El presente sitio web tiene como finalidad informar a los usuarios sobre los servicios
            profesionales que ofrece Gestorías Moreno Martín Alhambra S.L.P. y facilitar el contacto
            con la empresa.
            <br />
            <br />
            La información contenida en este sitio web es de carácter general e informativo y no
            constituye asesoramiento profesional. Para obtener asesoramiento personalizado, póngase
            en contacto con nosotros.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            3. Condiciones de uso
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            El acceso y uso de este sitio web atribuye la condición de usuario e implica la
            aceptación de las presentes condiciones de uso.
            <br />
            <br />
            El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que
            Gestorías Moreno Martín Alhambra S.L.P. ofrece en su sitio web y a no emplearlos para
            actividades ilícitas o contrarias a la buena fe y al orden público.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            4. Propiedad intelectual e industrial
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Todos los contenidos del sitio web, incluyendo textos, imágenes, logotipos, iconos,
            software y cualquier otro material, son propiedad de Gestorías Moreno Martín Alhambra
            S.L.P. o de sus respectivos autores, y están protegidos por las leyes de propiedad
            intelectual e industrial.
            <br />
            <br />
            Queda prohibida su reproducción, distribución, comunicación pública o transformación sin
            autorización expresa del titular.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            5. Responsabilidad
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Gestorías Moreno Martín Alhambra S.L.P. adopta las medidas razonables para garantizar la
            exactitud y actualización de los contenidos, si bien no garantiza la ausencia de errores
            ni asume responsabilidad por daños derivados del uso de la información publicada cuando
            dichos daños no sean imputables directamente a la entidad.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            6. Enlaces externos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Este sitio web puede contener enlaces a páginas de terceros. Gestorías Moreno Martín
            Alhambra S.L.P. no se responsabiliza del contenido ni de las políticas de privacidad de
            dichos sitios, ni garantiza la disponibilidad o correcto funcionamiento de los mismos.
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            7. Protección de datos
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Para información sobre el tratamiento de datos personales, consulte nuestra{" "}
            <MKTypography
              component="a"
              href="/politica-privacidad"
              color="info"
              sx={{ textDecoration: "underline" }}
            >
              Política de Privacidad
            </MKTypography>
            .
          </MKTypography>

          <MKTypography variant="h3" mb={1}>
            8. Legislación aplicable y jurisdicción
          </MKTypography>
          <MKTypography variant="body2" color="text" mb={3}>
            Las presentes condiciones se rigen por la legislación española. Para la resolución de
            cualquier controversia, cuando la normativa aplicable lo permita, las partes se
            someterán a los Juzgados y Tribunales de Granada. En caso de consumidores y usuarios,
            será competente el órgano jurisdiccional que determine la legislación vigente.
          </MKTypography>

          <MKTypography variant="caption" color="text">
            Última actualización: Junio 2026
          </MKTypography>
        </Container>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default AvisoLegal;
